// Components
import { EyeIcon, TrashIcon } from '@/icons';
import { StyledAction, StyledButton, StyledCard, StyledName } from './UploadCardStyles';

// Models
import { IFile } from '@/models/file.model';

// Helpers
import { getFileIcon } from '../../helpers';

type TUploadCardProps = {
  onPreview?: (file: IFile) => void;
  onDelete?: (file: IFile) => void;
  file: IFile;
  additionalInfo?: React.ReactNode;
};

const UploadCard = ({ onDelete, onPreview, file, additionalInfo }: TUploadCardProps) => {
  const handleDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onDelete?.(file);
  };
  const handlePreview = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onPreview?.(file);
  };

  return (
    <StyledCard>
      <StyledName>
        {getFileIcon(file.name)}
        <div>
          <span>{file.name}</span>
          {additionalInfo && <div>{additionalInfo}</div>}
        </div>
      </StyledName>
      <StyledAction>
        {onPreview && (
          <StyledButton onClick={handlePreview} $color="ORANGE_PRIMARY">
            <EyeIcon />
          </StyledButton>
        )}
        {onDelete && (
          <StyledButton onClick={handleDelete}>
            <TrashIcon />
          </StyledButton>
        )}
      </StyledAction>
    </StyledCard>
  );
};

export default UploadCard;
